import React from 'react'
import './FooterFour.css'
export default function FooterFour() {
  return (
      <div className="footerFourContainer">
          <div className="footerFour">
          <div className="copyright">Copyright Ⓒ 2022, Leverage Edu. All rights reserved.</div>
          <button className="backToTop">Back to Top</button>
          </div>
          <img src="https://images.leverageedu.com/homepage/footer-background.png" alt="" className='footerBottomImage' />
    </div>
  )
}
